<template>
  <div class="reward-item" @click="$emit('click')">
    <div class="reward-item__image">
      <img v-if="item.imageFileUrl" :src="item.imageFileUrl" :alt="item.title" />
      <img v-else src="@/assets/img/blip-logo.png" :alt="item.title" />
      <span class="reward-item__badge" :class="item.isVisible ? 'reward-item__badge--on' : 'reward-item__badge--off'">
        {{ item.isVisible ? "ON" : "OFF" }}
      </span>
    </div>
    <div class="reward-item__body">
      <div class="reward-item__text">
        <div class="reward-item__artist-line">
          <span class="reward-item__artist">{{ item.unitName }}</span>
          <span v-if="item.artistId" class="reward-item__member">{{ item.artistName || item.memberName }}</span>
        </div>
        <p class="reward-item__title">{{ item.title }}</p>
      </div>
      <div v-if="item.locationName" class="reward-item__location">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 1.5C5.514 1.5 3.5 3.514 3.5 6C3.5 9.5 8 14.5 8 14.5C8 14.5 12.5 9.5 12.5 6C12.5 3.514 10.486 1.5 8 1.5ZM8 7.5C7.172 7.5 6.5 6.828 6.5 6C6.5 5.172 7.172 4.5 8 4.5C8.828 4.5 9.5 5.172 9.5 6C9.5 6.828 8.828 7.5 8 7.5Z"
            fill="#7a7a7a"
          />
        </svg>
        <span>{{ item.locationName }}</span>
      </div>
      <div class="reward-item__footer">
        <span v-if="item.publishedAt" class="reward-item__period">{{ formatDate(item.publishedAt) }}</span>
        <div class="reward-item__platform">
          <span class="reward-item__platform-badge" :class="item.link ? 'reward-item__platform-badge--on' : 'reward-item__platform-badge--off'">앱</span>
          <span class="reward-item__platform-badge" :class="item.webLink ? 'reward-item__platform-badge--on' : 'reward-item__platform-badge--off'">웹</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RewardItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate(dateStr) {
      const d = new Date(dateStr);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const hh = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${yyyy}.${mm}.${dd} ${hh}:${min}`;
    },
  },
};
</script>

<style scoped lang="scss">
.reward-item {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
  transition: box-shadow 0.15s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  &__image {
    position: relative;
    width: 100%;
    height: 160px;
    border-radius: 12px;
    border: 1px solid #ededed;
    overflow: hidden;
    background: #1b1b1b;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__badge {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;

    &--on {
      background: rgba(0, 200, 100, 0.85);
      color: #fff;
    }

    &--off {
      background: rgba(0, 0, 0, 0.45);
      color: #fff;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 4px;
  }

  &__text {
    display: flex;
    flex-direction: column;
  }

  &__artist-line {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__artist {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.4px;
    color: #1b1b1b;
  }

  &__member {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: -0.4px;
    color: #7a7a7a;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #1b1b1b;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  &__location {
    display: flex;
    align-items: center;
    gap: 2px;

    span {
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: -0.4px;
      color: #7a7a7a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
  }

  &__period {
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
    color: #aaa;
  }

  &__platform {
    display: flex;
    gap: 4px;
  }

  &__platform-badge {
    padding: 1px 7px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;

    &--on {
      background: #e8f5e9;
      color: #2e7d32;
    }

    &--off {
      background: #f0f0f0;
      color: #aaa;
    }
  }
}
</style>
